import React, { useCallback, useEffect } from 'react';

import { loadClient } from '@justgiving/chrome';
import { PageView, TrackingProvider } from '@justgiving/react-tracking';

import styles from './Page.scss';

import useBasePageQuery from '../../hooks/useBasePageQuery';
import analytics from '../../utils/analytics';
import { filterByTypename } from '../../utils/graphql';

const baseTrackingData = {};

const Page: React.FunctionComponent = ({ children }) => {
  const basePageData = useBasePageQuery();

  const headerimage = basePageData?.data?.page?.branding?.headerImage;

  const campaignPageRelationships =
    basePageData?.data?.page?.relationships?.campaigns.nodes[0];
  const charity = basePageData?.data?.page?.relationships?.beneficiaries?.nodes
    ? filterByTypename(
        basePageData.data?.page?.relationships?.beneficiaries?.nodes,
        'Charity',
      )
    : null;
  const charityId = charity?.[0]?.legacyId;
  const eventId = basePageData?.data?.page?.relationships?.events?.nodes[0]?.id;
  const isSitebuilder = campaignPageRelationships?.isSitebuilder; // TODO: update this once isSitebuilder flag has been replaced

  const headerType = useCallback(() => {
    if (headerimage && isSitebuilder) {
      return 'sitebuilder';
    }
    if (headerimage) {
      return 'branded';
    }
    return 'consumer';
  }, [headerimage, isSitebuilder]);

  useEffect(() => {
    loadClient({
      headerVariant: headerType(),
      footerVariant: headerimage ? 'branded' : 'full',
    });
  }, [headerimage, headerType]);

  return (
    <TrackingProvider
      analytics={analytics}
      defaultTrackingData={{
        page_id: basePageData?.data?.page?.legacyId,
        event_label: basePageData?.data?.page?.legacyId,
        event_category: basePageData?.data?.page?.type,
        charity_id: charityId,
        event_id: eventId,
      }}
    >
      <div data-qa="page-wrapper" className={styles.page}>
        <PageView trackingData={baseTrackingData}>{children}</PageView>
      </div>
    </TrackingProvider>
  );
};

export default Page;
